
export default {
  name: 'Links',

  data() {
    return {
      isOpeningLink: false,
      links: []
    }
  },

  created() {
    this.fetchLinks()
  },

  methods: {
    async fetchLinks() {
      const { response } = await this.$api.link(this.fetchLinksApi).getActive()

      this.links = response.data.map(link => ({
        ...link,
        isOpening: false
      }))
    },

    visitLink(link) {
      try {
        link.isOpening = true
        this.$api.link(this.$openWindowApi).logClick(link.id)
      } catch (error) {
        console.error('Error logging link click', error)
      } finally {
        setTimeout(() => {
          link.isOpening = false
          this.$openWindow(link.buttonLink)
        }, 500)
      }
    }
  }
}
